import { ProductCard } from "components/ui";
import useStockInCatalog from "hooks/useStockInCatalog";
import { useGlobalContext } from "context/GlobalContext";
import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { addToCart, initCart, removeFromCart } from "store/cartSlice";
import { useLocation } from "react-router-dom";
import { Height } from "@mui/icons-material";

const CatalogueHookProduct = ({ design, innerChnages, isEdit, checkedItems, handleCheckboxChange, cartData, allData }) => {
  const { btnTitle, setBtnTitle } = useStockInCatalog(design);

  const location = useLocation();
  const { removeCart, setAllAdded, catalogData } = useGlobalContext();

  const dispatch = useDispatch();

  const selectedCartProducts = useMemo(
    () => ({
      ...design,
      isAddedInCart: true,
    }),
    [design]
  );

  const handleAddToCartBtn = React.useCallback(() => {
    dispatch(
      addToCart({
        product: selectedCartProducts,
        location: location,
      }
      )

      // {
      //   product: selectedCartProducts,
      //   location: location,
      // }
    );
  }, [dispatch, selectedCartProducts]);

  const handleRemoveCart = React.useCallback(() => {
    dispatch(removeFromCart(selectedCartProducts));
  }, [dispatch, selectedCartProducts]);

  // const handleAddToCartBtn = () => {
  //   setBtnTitle("Added");
  //   addToCart(selectedCartProducts);
  //   window.dispatchEvent(new Event("cartUpdated"));
  // };

  // const handleRemoveCart = () => {
  //   setBtnTitle("Add");
  //   removeFromCart(selectedCartProducts);
  //   sessionStorage.setItem("RecentlyRemoved", JSON.stringify(selectedCartProducts));
  //   window.dispatchEvent(new Event("cartUpdated"));
  // };

  const isAddedInCart = useMemo(() => {
    return cartData.some((item) => item.styleNumber === design.styleNumber);
  }, [cartData]);

  useEffect(() => {
    setBtnTitle(isAddedInCart ? "Added" : "Add");
  }, [isAddedInCart]);

  useEffect(() => {
    dispatch(initCart());
  }, [dispatch]);

  // const selectedCartProducts = useMemo(
  //   () => ({
  //     ...design,
  //     isAddedInCart: true,
  //   }),
  //   [design]
  // );

  useEffect(() => {
    if (catalogData?.length > 0) {
      const existingStyleNumbers = new Set(cartData.map((item) => item.styleNumber) || []);
      const allDesignsAdded = catalogData.every((design) => design?.styleNumber && existingStyleNumbers.has(design.styleNumber));

      setAllAdded(allDesignsAdded);
    }
    return () => {
      setAllAdded(false);
    };
  }, [cartData, catalogData]);

  return (
    <ProductCard
      data={design}
      removeCart={() => (innerChnages ? handleRemoveCart() : removeCart(design))}
      addtoCart={handleAddToCartBtn}
      selectedCartProducts={selectedCartProducts}
      isBtn={innerChnages}
      btnTilte={btnTitle}
      hoverEffect={isEdit}
      handleCheckboxChange={handleCheckboxChange}
      checkedItems={checkedItems}
      style={{
        maxWidth: isEdit ? "474px" : "474px",
        minWidth: isEdit ? "474px" : "474px",
        Height:isEdit?"250px":"250px",
      }}
      updateCatagoryData={cartData}
      allData={allData}
    />
  );
};

export default CatalogueHookProduct;
